import "./Role.scss";

export function Role({ role, className })
{
    if (!role)
        return undefined;
    
    return <div className={className} styleName={`role ${role.replace(" ", "-")}`} />
}